
import { testimonials } from '../../../mocks/testimonials';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="relative">
          <svg
            className="absolute -top-12 -left-8 w-24 h-24 text-gray-200"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 60 Q 30 20, 50 30 T 80 40"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          </svg>

          <div className="bg-gray-900 rounded-[32px] overflow-hidden">
            <div className="grid md:grid-cols-5 gap-0">
              <div className="md:col-span-2 relative">
                <div className="absolute -left-8 top-0 bottom-0 w-1/3 bg-gray-100 rounded-2xl hidden md:block"></div>
                <img
                  src={testimonials[0].image}
                  alt={testimonials[0].name}
                  className="relative w-full h-full object-cover object-center min-h-[400px] md:min-h-[500px] rounded-l-2xl"
                />
              </div>

              <div className="md:col-span-3 p-12 md:p-16 flex flex-col justify-center">
                <div className="text-amber-400 text-7xl md:text-8xl font-serif mb-6">"</div>
                <p className="text-2xl md:text-3xl font-serif text-white leading-relaxed mb-8">
                  {testimonials[0].quote}
                </p>
                <div className="mb-6">
                  <p className="text-xl font-bold text-white">{testimonials[0].name}</p>
                  <p className="text-white/70">{testimonials[0].project}</p>
                </div>
                <button className="self-start px-8 py-3 bg-coral-500 hover:bg-coral-600 text-gray-900 rounded-full font-medium transition-colors whitespace-nowrap cursor-pointer" style={{ backgroundColor: '#FF6B6B' }}>
                  Read More Stories
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-12">
          {testimonials.slice(1, 3).map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-3xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.project}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}